import { TwcOverlayTemplate } from "@/components/signup/layouts/product-overlay-template";
import { SignupBackgroundLayout } from "@/components/signup/layouts/signup-background-layout";
import { SiteActivation } from "@/components/signup/site-activation/site-activation";
import { TeamworkCollectionLogo } from "@/components/signup/utils/logos/teamwork-collection-logo";
import { checkFeatureFlagGate } from "@/utils/feature-flags/check-feature-flag";
import { featureFlags } from "@/utils/feature-flags/feature-flag-manifest";

import { CreateAWorkspaceText } from "../../components/create-a-workspace-heading";
import { Headings } from "../../components/headings";
import { WorkspacesAreWhereText } from "../../components/sub-heading";

export const NewUser = () => {
    const twcSignupOverlayEnrolled = checkFeatureFlagGate(
        featureFlags.cfind5480TwcSignupOverlay
    );

    const content = (
        <>
            <Headings
                main={<CreateAWorkspaceText />}
                sub={<WorkspacesAreWhereText />}
            />
            <SiteActivation />
        </>
    );

    if (twcSignupOverlayEnrolled) {
        return <TwcOverlayTemplate size="sm">{content}</TwcOverlayTemplate>;
    }

    return (
        <SignupBackgroundLayout ProductLogo={<TeamworkCollectionLogo />}>
            {content}
        </SignupBackgroundLayout>
    );
};
